export default __webpack_public_path__ + "static/sticky-logo-4d942627f6315de73648b692fa4a37b1.svg";